module.exports = __webpack_public_path__ + "media/images/company/cp07-0a19f9c5b8f7fd02f20eb8bcaacab126.png";